
export default {
    name: 'Button',
    props: {
        theme: {
            type: String,
            default: () => 'primary',
            validator (value) {
                return ['primary', 'secondary', 'danger'].includes(value)
            }
        },
        loading: {
            type: Boolean,
            default: () => false
        }
    },
    methods: {
        getButtonClass () {
            return {
                primary: 'bg-primary-600 border-primary-600 text-white hover:bg-primary-700 disabled:hover:bg-primary-600 focus:ring-primary-100',
                secondary: 'bg-white border-gray-300 text-gray-700 hover:bg-gray-50 disabled:hover:bg-white focus:ring-gray-100',
                danger: 'bg-red-600 border-red-600 text-white hover:bg-red-700 disabled:hover:bg-red-600 focus:ring-red-100',
            }[this.theme]
        }
    }
}
